import { Box, IconButton, Menu, MenuItem } from "@mui/material";
import { Logout, AccountCircle } from "@mui/icons-material";
import { useState } from "react";
import useAuthStore from "../../../../utils/authStore";

const UserMenu = () => {
  const clearAccessToken = useAuthStore((state) => state.clearAccessToken);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSignout = () => {
    setAnchorEl(null);
    clearAccessToken();
    localStorage.removeItem("auth-storage");
    window.location.href = "/login";
  };

  return (
    <Box pt={4}>
      <IconButton onClick={handleOpen} sx={{ p: 0 }}>
        <AccountCircle sx={{ color: "white", fontSize: 38 }} />
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem onClick={handleSignout}>
          <Logout fontSize="small" sx={{ mr: 1 }} /> Sign Out
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default UserMenu;
